import React, { useState } from "react";
import Navigation from "../components/Navigation";
import Zoom from "react-reveal";
import Hero from "../components/Hero";
export default function Landing(props) {
	const [name] = useState(props.name);
	const [work] = useState(props.work);
	return (
		<>
			<Navigation />
			<Zoom>
				<section className="container mx-auto mt-8 p-5">
					<Hero name={name} title={work} />
				</section>
			</Zoom>
		</>
	);
}
